<template lang="html">
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col cols class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle d-block">Avaliação</span>
        <h3 class="page-title d-inline">
          Respostas do usuário:
          <d-link :to="{ name: 'admin-customer-edit', params: { customerId: answers.user.customer.id }}" v-if="answers.user.customer">{{ answers.user.name }} </d-link>
        </h3>
        <d-link class="btn btn-primary text-white float-right " :to="{ name: 'admin-rating-answers', params: { page: 1 }}">Voltar a lista</d-link>
      </d-col>
    </d-row>

    <!-- Content -->
    <rating-user-answer ref="questionsForm" />
  </d-container>
</template>


<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import Questions from '_modules/rating/components/Questions.vue';
import RatingUserAnswer from '../components/RatingUserAnswer.vue';
import { MODEL_RATING, _LOAD_MODEL_ } from '../components/RatingModel';

export default {
  name: 'rating-questions',
  components: {
    Questions,
    RatingUserAnswer,
  },
  computed: {
    answers() {
      const { questionsAndAnswers } = this.$store.state.rating;
      if (questionsAndAnswers) {
        Events.$emit(_LOAD_MODEL_, questionsAndAnswers);
        return questionsAndAnswers;
      }
      return {
        user: { name: null },
        rating: { ...MODEL_RATING },
      };
    },
  },
  data() {
    return {
      editTitle: false,
      name: null,
    };
  },
  methods: {
    ...mapActions([
      'getUserAnswer',
      'activeAlert',
      'updateRating',
    ]),
    getUserModel() {
      this.getUserAnswer(parseInt(this.$route.params.userId, Number));
    },
  },
  mounted() {
    if (this.$route.params.userId) {
      this.getUserModel();
    }
  },
};
</script>

